import { render, staticRenderFns } from "./forward.vue?vue&type=template&id=2228f4bc&scoped=true"
import script from "./forward.vue?vue&type=script&lang=ts"
export * from "./forward.vue?vue&type=script&lang=ts"
import style0 from "./forward.vue?vue&type=style&index=0&id=2228f4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228f4bc",
  null
  
)

export default component.exports